import {
  addToWallet, applicationComplete,
  applicationTimeout,
  cancelApplication,
  dspTimeout, offerResponse,
  receivePrescreenApplicationResult, receiveAccountExists,
  submitApplication, submitPrescreenApplication,
  viewPage
} from 'fmc-sdk';

export const FMC_ACTIONS_FOR_ANALYTICS = [
  viewPage,
  dspTimeout,
  addToWallet,
  applicationTimeout,
  submitApplication,
  receivePrescreenApplicationResult,
  receiveAccountExists,
  cancelApplication,
  applicationComplete,
  offerResponse,
  submitPrescreenApplication,
];
